import apiClient from '../client.js'

async function createCategory(scope, payload) {
  return apiClient.post(`/${scope}/tickets/categories`, payload)
}

async function updateCategory(scope, id, patch) {
  return apiClient.patch(`/${scope}/tickets/categories/${id}`, patch)
}

async function deleteCategory(scope, id) {
  return apiClient.delete(`/${scope}/tickets/categories/${id}`)
}

class CategoryService {
  create = {
    /**
     * Create a category under the settings scope.
     *
     * @param {string} scope - Settings API URL prefix (`ticket-account` or `ticket-group/:id`).
     * @param {object} payload
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    async category(scope, payload) {
      return createCategory(scope, payload)
    },
  }

  update = {
    /**
     * Update one category under the settings scope.
     *
     * @param {string} scope - Settings API URL prefix (`ticket-account` or `ticket-group/:id`).
     * @param {string} id
     * @param {object} patch
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    async category(scope, id, patch) {
      return updateCategory(scope, id, patch)
    },
  }

  delete = {
    /**
     * Delete one category under the settings scope.
     *
     * @param {string} scope - Settings API URL prefix (`ticket-account` or `ticket-group/:id`).
     * @param {string} id
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    async category(scope, id) {
      return deleteCategory(scope, id)
    },
  }
}

export default new CategoryService()
